import { render, staticRenderFns } from "./AttributeValueWithValidation.vue?vue&type=template&id=80054990&"
import script from "./AttributeValueWithValidation.vue?vue&type=script&lang=ts&"
export * from "./AttributeValueWithValidation.vue?vue&type=script&lang=ts&"
import style0 from "./AttributeValueWithValidation.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports